import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import accessClientPortalBackground from '../../../../../assets/images/access-client-portal.webp';
import { figmaLetterSpacing } from '../../../../../ui/utils';
import { SectionHeading } from '../../styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  padding: '140px 114px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  borderRadius: '40px',
  background: `linear-gradient(180deg, rgba(82, 31, 12, 0) 0%, #521F0C 100%), url(${accessClientPortalBackground})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  boxShadow: `
    -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
     4px  4px 15px   0px rgba(205, 214, 223, 0.25)
  `,
  maxWidth: 928,
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: '80px 60px',
    borderRadius: '24px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '60px 24px',
    borderRadius: '16px',
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 50,
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    gap: 40,
  },
  [theme.breakpoints.down('sm')]: {
    gap: 30,
  },
}));

export const TextContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 14,
  '&::before': {
    display: 'block',
    content: '""',
    marginTop: '45.25%',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  [theme.breakpoints.down('md')]: {
    gap: 12,
  },
  [theme.breakpoints.down('sm')]: {
    gap: 10,
  },
}));

export const Title = styled(SectionHeading)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  fontSize: 50,
  color: colors.whiteText,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: 36,
    lineHeight: '42px',
    letterSpacing: figmaLetterSpacing(36, -1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 28,
    lineHeight: '34px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 500,
  lineHeight: '32px',
  letterSpacing: figmaLetterSpacing(22, 3),
  fontSize: 22,
  color: colors.whiteText,
  textAlign: 'center',
  textWrap: 'balance',
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
    lineHeight: '28px',
    letterSpacing: figmaLetterSpacing(20, 3),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 15,
    lineHeight: '21px',
    letterSpacing: figmaLetterSpacing(18, 3),
  },
  '& a': {
    fontWeight: 600,
    textDecoration: 'underline',
    color: colors.whiteText,
  },
}));
